import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'


export interface AppState {
  headerMenuEnabled: boolean
  isKiosk: boolean
}

const initialState: AppState = {
  headerMenuEnabled: true,
  isKiosk: false,
}

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    toggleHeaderMenu: (state, action: PayloadAction<boolean>) => {
      state.headerMenuEnabled = action.payload
    },
    toggleKioskMode: (state, action: PayloadAction<boolean>) => {
      state.isKiosk = action.payload
    },
  },
})

// Action creators are generated for each case reducer function
export const {
  toggleHeaderMenu,
  toggleKioskMode,
} = appSlice.actions

export default appSlice.reducer
